import { AssignmentQuestionsWorkedOn } from "./assignment_questions-worked-on"

export interface Organization {
  isPro: boolean
  organizationId: string
  organizationName: string
  assignmentQuestionsWorkedOn: AssignmentQuestionsWorkedOn | undefined
  activeTeachers: number
}

export interface Cta {
  copy: string
  link: string
}

export class UserConversionJourney {
  constructor(
    public firstName: string,
    public lastName: string,
    public displayName: string,
    public lastActive: Date,
    public assignmentCount: number,
    public assignmentQuestionsWorkedOn: AssignmentQuestionsWorkedOn | undefined,
    public userId: string,
    public organizations: Organization[],
    public progressPercent: number,
    public usageLimit: number,
    public showOnIos: boolean,
    public blocking: boolean,
    public title: string,
    public subTitle: string,
    public benefits: string[],
    public cta: Cta,
    public metric: string,
  ) {}

  get fullName(): string {
    return `${this.firstName} ${this.lastName}`
  }

  get displayNameOrFullName(): string {
    return this.displayName || this.fullName
  }
}
